module.exports = __webpack_public_path__ + "img/10858_L.eb7393ed.png";